import Countdown from '../components/react/Countdown/Countdown';

const React = require('react');
const ReactDOM = require('react-dom');

const CountdownUtils = require('../components/react/Countdown/CountdownUtils');

/**
 * Computes current time in seconds and starts all the countdowns.
 * It takes the timezone offset from the server into account
 * (for case when it is summer time and user orders from different timezone)
 * @param {array} countdownList
 */
function startAllCountdowns(countdownList) {

  const clientDate = new Date();
  const clientTimeInSeconds = parseInt(clientDate.getTime() / 1000, 10);
  const clientTimezoneOffsetInSeconds = clientDate.getTimezoneOffset() * 60;
  const serverTimezoneOffsetInSeconds = ((window.DCG && window.DCG.serverTimezoneOffset) || 0) * 60;

  const offsetInSeconds = serverTimezoneOffsetInSeconds - clientTimezoneOffsetInSeconds;
  const currentTimeInSeconds = clientTimeInSeconds - offsetInSeconds;

  for (let i = 0, len = countdownList.length; i < len; i++) {
    initCountdown(countdownList[i], currentTimeInSeconds);
  }
}

/**
 * Starts the countdown
 * @param {element} element
 * @param {number} currentTimeInSeconds
 */
function initCountdown(element, currentTimeInSeconds) {
  const countdownSetup = {
    currentTimeInSeconds,
    startTimeInSeconds: dateStringToSeconds(element.getAttribute('data-start-date') || 0),
    endTimeInSeconds: dateStringToSeconds(element.getAttribute('data-end-date') || 0),
    messageStartTimeInSeconds: dateStringToSeconds(
      element.getAttribute('data-message-start-date') || 0
    ),
    messageEndTimeInSeconds: dateStringToSeconds(
      element.getAttribute('data-message-end-date') || 0
    ),

    message: element.getAttribute('data-message') || '',
    messageBefore: element.getAttribute('data-message-before') || '',
    messageAfter: element.getAttribute('data-message-after') || '',

    amberCountdown: parseInt(element.getAttribute('data-amber-countdown') || 0, 10) * 60,
    redCountdown: parseInt(element.getAttribute('data-red-countdown') || 0, 10) * 60,
    deliveryType: element.getAttribute('data-delivery-type'),
    countdownType: element.getAttribute('data-countdown-type'),
    onChange: (payload) => {
      ReactDOM.render(
        <Countdown
          color={payload.color}
          daysShow={payload.daysShow}
          hoursShow={payload.hoursShow}
          minutesShow={payload.minutesShow}
          secondsShow={payload.secondsShow}
          secondsLabel={payload.secondsLabel}
          minutesLabel={payload.minutesLabel}
          hoursLabel={payload.hoursLabel}
          daysLabel={payload.daysLabel}
          days={payload.days}
          hours={payload.hours}
          minutes={payload.minutes}
          seconds={payload.seconds}
          messageFirstPart={payload.messageFirstPart}
          messageSecondPart={payload.messageSecondPart}
          display={payload.display}
        />,
        element
      );
      setVisibility(element, payload.display);
    }
  };
  const countdownUtils = new CountdownUtils(countdownSetup);
  countdownUtils.start(element);
}

/**
 * Sets the visibility of the countdown wrapper and it's substitute
 * @param {element} element
 * @param {bool} countdownVisible
 */
function setVisibility(element, countdownVisible) {

  if (element.getAttribute('data-on-zero-hide')) {
    const listItemWithCountdown = element.closest(element.getAttribute('data-on-zero-hide'));

    listItemWithCountdown.style.display = countdownVisible ? 'block' : 'none';

    listItemWithCountdown.parentElement
      .querySelector(element.getAttribute('data-on-zero-show')).style.display =
      countdownVisible ? 'none' : 'block';
  }
}

/**
 * Converts date string to seconds
 * @param {string} string
 * @returns {number}
 */
function dateStringToSeconds(string) {
  return string ? parseInt(new Date(string).getTime() / 1000, 10) : 0;
}

/**
 * Init countdowns if they are present on page
 * Use timezone offset from the server converted
 */

export default function initCountdowns() {
  window.appState.dispatch({
    type: 'NEXT_DAY_DELIVERY_COUNTDOWN',
    payload: {
      enabled: false
    }
  });
  const countdowns = document.querySelectorAll('[data-component="countdown"]');
  if (countdowns) {
    if (document.readyState !== 'loading') {
      startAllCountdowns(countdowns);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        startAllCountdowns(countdowns);
      }, false);
    }
  }
}
